<youtube-player [videoId]="video_id"
                (stateChange)="playerStateChanged($event.data)">
</youtube-player>
